export const adfoxOptions = {
    main: {
        toPad: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17649390316364666",
                    params: {
                        p1: "dlnax",
                        p2: "itrw",
                    },
                },
            ],
        },
        ir1: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17408189579286666",
                    params: {
                        p1: "dgjfi",
                        p2: "itrx",
                    },
                },
            ],
        },
        ir2: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_1740818984321666",
                    params: {
                        p1: "dgjfj",
                        p2: "itry",
                    },
                },
            ],
        },
        ir3: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17408190071095666",
                    params: {
                        p1: "dgjfk",
                        p2: "iuak",
                    },
                },
            ],
        },
        ir4: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17408193689367666",
                    params: {
                        p1: "dgjfl",
                        p2: "iual",
                    },
                },
            ],
        },
        feed: {
            fullMob: [
                {
                    blockId: "R-A-1598227-177",
                    type: "feed",
                },
            ],
            prevMob: [
                {
                    blockId: "R-A-1598227-177",
                    type: "feed",
                },
            ],
        },
        fullScreen: {
            fullMob: {
                blockId: "R-A-1598227-178",
                type: "fullscreen",
                platform: "touch",
            },
        },
        inImageAd: null,
    },
    48306: {
        toPad: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17649390316364666",
                    params: {
                        p1: "dlnax",
                        p2: "itrw",
                    },
                },
            ],
        },
        ir1: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17408189579286666",
                    params: {
                        p1: "dgjfi",
                        p2: "itrx",
                    },
                },
            ],
        },
        ir2: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_1740818984321666",
                    params: {
                        p1: "dgjfj",
                        p2: "itry",
                    },
                },
            ],
        },
        ir3: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17408190071095666",
                    params: {
                        p1: "dgjfk",
                        p2: "iuak",
                    },
                },
            ],
        },
        ir4: {
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17408193689367666",
                    params: {
                        p1: "dgjfl",
                        p2: "iual",
                    },
                },
            ],
        },
        feed: {
            fullMob: [
                {
                    blockId: "R-A-1598227-177",
                    type: "feed",
                },
            ],
            prevMob: [
                {
                    blockId: "R-A-1598227-177",
                    type: "feed",
                },
            ],
        },
        fullScreen: {
            fullMob: {
                blockId: "R-A-1598227-178",
                type: "fullscreen",
                platform: "touch",
            },
        },
        inImageAd: null,
    },
    2: {
        fullScreen: null,
        inImageAd: null,
    },
    3: {
        fullScreen: {
            fullPc: {
                blockId: "R-A-1598227-180",
                type: "fullscreen",
                platform: "touch",
            },
            fullMob: {
                blockId: "R-A-1598227-180",
                type: "fullscreen",
                platform: "touch",
            },
            prevPc: {
                blockId: "R-A-1598227-180",
                type: "fullscreen",
                platform: "touch",
            },
            prevMob: {
                blockId: "R-A-1598227-180",
                type: "fullscreen",
                platform: "touch",
            },
        },
        inImageAd: null,
    },
    4: {
        // Дубль -182 под слот перед текстом: renderTo отличается от ir2, иначе
        // два контейнера получат одинаковый id и второй блок не отрисуется.
        ir1: {
            fullPc: { renderTo: "yandex_rtb_R-A-1598227-182-1", blockId: "R-A-1598227-182" },
            fullMob: { renderTo: "yandex_rtb_R-A-1598227-182-1", blockId: "R-A-1598227-182" },
            prevPc: { renderTo: "yandex_rtb_R-A-1598227-182-1", blockId: "R-A-1598227-182" },
            prevMob: { renderTo: "yandex_rtb_R-A-1598227-182-1", blockId: "R-A-1598227-182" },
        },
        ir2: {
            fullPc: { renderTo: "yandex_rtb_R-A-1598227-182", blockId: "R-A-1598227-182" },
            fullMob: { renderTo: "yandex_rtb_R-A-1598227-182", blockId: "R-A-1598227-182" },
            prevPc: { renderTo: "yandex_rtb_R-A-1598227-182", blockId: "R-A-1598227-182" },
            prevMob: { renderTo: "yandex_rtb_R-A-1598227-182", blockId: "R-A-1598227-182" },
        },
        ir3: {
            fullPc: { renderTo: "yandex_rtb_R-A-1598227-183", blockId: "R-A-1598227-183" },
            fullMob: { renderTo: "yandex_rtb_R-A-1598227-183", blockId: "R-A-1598227-183" },
            prevPc: { renderTo: "yandex_rtb_R-A-1598227-183", blockId: "R-A-1598227-183" },
            prevMob: { renderTo: "yandex_rtb_R-A-1598227-183", blockId: "R-A-1598227-183" },
        },
        ir4: {
            fullPc: { renderTo: "yandex_rtb_R-A-1598227-184", blockId: "R-A-1598227-184" },
            fullMob: { renderTo: "yandex_rtb_R-A-1598227-184", blockId: "R-A-1598227-184" },
            prevPc: { renderTo: "yandex_rtb_R-A-1598227-184", blockId: "R-A-1598227-184" },
            prevMob: { renderTo: "yandex_rtb_R-A-1598227-184", blockId: "R-A-1598227-184" },
        },
        fullScreen: {
            fullMob: {
                blockId: "R-A-1598227-185",
                type: "fullscreen",
                platform: "touch",
            },
        },
        feed: {
            fullMob: [
                {
                    blockId: "R-A-1598227-181",
                    type: "feed",
                },
            ],
            prevMob: [
                {
                    blockId: "R-A-1598227-181",
                    type: "feed",
                },
            ],
            fullPc: [
                {
                    blockId: "R-A-1598227-181",
                    type: "feed",
                },
            ],
            prevPc: [
                {
                    blockId: "R-A-1598227-181",
                    type: "feed",
                },
            ],
        },
        inImageAd: null,
    },
    5: {
        toPad: {
            fullPc: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17664740032373666",
                    params: {
                        p1: "dlusj",
                        p2: "jhkf",
                    },
                },
            ],
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17664740032373666",
                    params: {
                        p1: "dlusj",
                        p2: "jhkf",
                    },
                },
            ],
            prevPc: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17664740032373666",
                    params: {
                        p1: "dlusj",
                        p2: "jhkf",
                    },
                },
            ],
            prevMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17664740032373666",
                    params: {
                        p1: "dlusj",
                        p2: "jhkf",
                    },
                },
            ],
        },
        ir1: {
            prevPc: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17664740027083666",
                    params: {
                        p1: "dlusk",
                        p2: "jhkk",
                    },
                },
            ],
            prevMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17664740027083666",
                    params: {
                        p1: "dlusk",
                        p2: "jhkk",
                    },
                },
            ],
            fullPc: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17664740027083666",
                    params: {
                        p1: "dlusk",
                        p2: "jhkk",
                    },
                },
            ],
            fullMob: [
                {
                    ownerId: 407082,
                    containerId: "adfox_17664740027083666",
                    params: {
                        p1: "dlusk",
                        p2: "jhkk",
                    },
                },
            ],
        },
        inImageAd: null,
        fullScreen: {
            fullMob: {
                blockId: "R-A-1598227-188",
                type: "fullscreen",
                platform: "touch",
            },
            prevMob: {
                blockId: "R-A-1598227-188",
                type: "fullscreen",
                platform: "touch",
            },
        },
    },
    66972: {
        ir1: {
            fullMob: { renderTo: "yandex_rtb_R-A-1598227-250", blockId: "R-A-1598227-250" },
        },
        ir2: {
            fullMob: { renderTo: "yandex_rtb_R-A-1598227-251", blockId: "R-A-1598227-251" },
        },
        ir3: {
            fullMob: { renderTo: "yandex_rtb_R-A-1598227-252", blockId: "R-A-1598227-252" },
        },
        ir4: {
            fullMob: { renderTo: "yandex_rtb_R-A-1598227-253", blockId: "R-A-1598227-253" },
        },
        fullScreen: {
            fullMob: {
                blockId: "R-A-1598227-248",
                type: "fullscreen",
                platform: "touch",
            },
            prevMob: {
                blockId: "R-A-1598227-248",
                type: "fullscreen",
                platform: "touch",
            },
        },
        feed: {
            fullMob: [
                {
                    blockId: "R-A-1598227-249",
                    type: "feed",
                },
            ],
            prevMob: [
                {
                    blockId: "R-A-1598227-249",
                    type: "feed",
                },
            ],
        },
        inImageAd: null,
    },
};
